var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPr = function SvgPr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-37.298 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(34.967) scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed0000",
    d: "M-37.298 0h768v512h-768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-37.298 102.4h768v102.4h-768zM-37.298 307.2h768v102.4h-768z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.298 0l440.69 255.67-440.69 255.34V0z",
    fill: "#0050f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.45 325.47l-47.447-35.432-47.214 35.78 17.56-58.144-47.128-35.904 58.305-.5L108.61 173.3l18.472 57.835 58.305.077-46.886 36.243 17.947 58.016z",
    fill: "#fff"
  }))));
};
export default __webpack_public_path__ + "assets/593e41501ba5f46e902c707b41cf257d.svg";
export { SvgPr as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/pr.svg